export const toErrorString = (err) => {
    if (!err)
        return "unknown error";
    if (typeof err === "string")
        return err;
    if (err instanceof Error)
        return `${err.name}: ${err.message}\n${err.stack ?? ""}`;
    const axiosData = err?.response?.data;
    if (axiosData) {
        try {
            return `HTTP ${err.response.status}: ${JSON.stringify(axiosData)}`;
        }
        catch {
            return `HTTP ${err.response.status}: [unserializable response data]`;
        }
    }
    try {
        return JSON.stringify(err);
    }
    catch {
        return Object.prototype.toString.call(err);
    }
};
